import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


@Component({
  selector: 'oaj-exportar-excel',
  imports: [],
  templateUrl: './exportar-excel.html',
  styleUrl: './exportar-excel.css',
})
export class ExportarExcel {
  @Input() data: any[] | null = [];
  @Input() fileName = 'reporte.xlsx';
  @Input() columns: { header: string; key: string; width?: number; transform?: (val: any, item?: any, index?: number) => any;  }[] = [];

  @Output() emitExport = new EventEmitter<void>();
  @Input() useEmitter = false;
  @Input() subtitle = '';
  @Input() supertitle = '';

   onExportClick() {
    if(this.useEmitter){
      this.emitExport.emit();
    } else{
      this.export();
    }
    
  }

  async export() {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Datos');
  worksheet.columns = this.columns;

  let currentRow = 1;

  if (this.supertitle) {
    worksheet.spliceRows(currentRow, 0, [this.supertitle]);
    worksheet.mergeCells(`A${currentRow}:${String.fromCharCode(64 + this.columns.length)}${currentRow}`);
    const supertitleCell = worksheet.getCell(`A${currentRow}`);
    // supertitleCell.font = { bold: true, size: 14 };
    // supertitleCell.alignment = { horizontal: 'center' };
    supertitleCell.font = { italic: false, size: 12 };
    supertitleCell.alignment = { horizontal: 'center' };
    currentRow++;
  }

  const titulo = this.fileName.replace('.xlsx', '');
  worksheet.spliceRows(currentRow, 0, [titulo]);
  worksheet.mergeCells(`A${currentRow}:${String.fromCharCode(64 + this.columns.length)}${currentRow}`);
  const titleCell = worksheet.getCell(`A${currentRow}`);
  titleCell.font = { bold: true, size: 16 };
  titleCell.alignment = { horizontal: 'center' };
  currentRow++;

  // Subtítulo (si existe)
  if (this.subtitle) {
    worksheet.spliceRows(currentRow, 0, [this.subtitle]);
    worksheet.mergeCells(`A${currentRow}:${String.fromCharCode(64 + this.columns.length)}${currentRow}`);
    const subtitleCell = worksheet.getCell(`A${currentRow}`);
    subtitleCell.font = { italic: false, size: 12 };
    subtitleCell.alignment = { horizontal: 'center' };
    currentRow++;
  }

  // Encabezados
  const headerRow = worksheet.getRow(currentRow);
  headerRow.eachCell(cell => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '1F4E78' } };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
  });

  // Datos
  this.data?.forEach((item, index) => {
    const row: any = {};
    this.columns.forEach(col => {
      let val = item[col.key];
      if (col.transform) {
        val = col.transform(val, item, index);
      }
      row[col.key] = val;
    });
    worksheet.addRow(row);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, this.fileName);
}


}
